// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttonTemplate__4qdJ {
  border: none;
  outline: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  min-width: fit-content;
  color: var(--black-color);
  @media (width<=768px) {
    padding: 6px 10px;
  }
  &:disabled{
    cursor: not-allowed;
  }
}

.buttonTemplate__4qdJ:hover {
}

.buttonTemplateGreen_q8yA5 {
  font-size: 14px;
  background-color: var(--_10a37f-background);
  transition: all 100ms;
  -webkit-transition: all 100ms;
  -moz-transition: all 100ms;
  -ms-transition: all 100ms;
  -o-transition: all 100ms;
  &:hover {
    background-color: var(--_0b745a-background);
  }
  color: var(--white-unic-color);
  &:disabled{
    background-color: #0d92708b;
  }
}

.buttonTemplateDiscard_blUXu {
  background-color: var(--b30634-background);
  color: var(--white-color);
  cursor: pointer;
}
.buttonTemplateWhite_b3mAA {
  background-color: var(--white-background);
  border: 1px solid var(--cb-border);
  color: var(--_0d-color);
}

.buttonTemplateWhite_b3mAA:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.buttonTemplateGray_jfNyC {
  background-color: var(--_6f6f81-background);
  border: 1px solid var(--_6f6f81-border);
  color: var(--white-color);
}
.buttonTemplateButton_pG8qe {
  text-decoration: underline;
  color: var(--_2-color);
  font-weight: 500;
  cursor: pointer;
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
  position: relative;
}

.buttonTemplate__4qdJ.filteredUserAutomationSelected_uY2az {
  position: relative;
}

.buttonTemplate__4qdJ.filteredUserAutomationSelected_uY2az:hover::after {
  content: "Crea y Selecciona un automata";
  position: absolute;
  top: 105%;
  width: 200px;
  color: var(--_0d-color);
  padding: 2px 4px;
  background: var(--white-background);
  border-radius: 6px;
  font-size: 12px;
  box-shadow: 0 1px 1px var(--_0000001a-shadow);
  z-index: 999999;
}

.buttonTemplateBorder_ZwAb1{
  border: 1px solid var(--cb-border);
  background-color: var(--white-background);
  padding: 8px;
}


.buttonTemplateLightGray_sX6TD{
  background-color: var(--ececf1-background);
  color: var(--_6e6e80-background);
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Button/Button.module.css"],"names":[],"mappings":"AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;AACA;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB;IACE,2CAA2C;EAC7C;EACA,8BAA8B;EAC9B;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,YAAY;AACd;;;AAGA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n.buttonTemplate {\n  border: none;\n  outline: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: \"Inter\", sans-serif;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  min-width: fit-content;\n  color: var(--black-color);\n  @media (width<=768px) {\n    padding: 6px 10px;\n  }\n  &:disabled{\n    cursor: not-allowed;\n  }\n}\n\n.buttonTemplate:hover {\n}\n\n.buttonTemplateGreen {\n  font-size: 14px;\n  background-color: var(--_10a37f-background);\n  transition: all 100ms;\n  -webkit-transition: all 100ms;\n  -moz-transition: all 100ms;\n  -ms-transition: all 100ms;\n  -o-transition: all 100ms;\n  &:hover {\n    background-color: var(--_0b745a-background);\n  }\n  color: var(--white-unic-color);\n  &:disabled{\n    background-color: #0d92708b;\n  }\n}\n\n.buttonTemplateDiscard {\n  background-color: var(--b30634-background);\n  color: var(--white-color);\n  cursor: pointer;\n}\n.buttonTemplateWhite {\n  background-color: var(--white-background);\n  border: 1px solid var(--cb-border);\n  color: var(--_0d-color);\n}\n\n.buttonTemplateWhite:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.buttonTemplateGray {\n  background-color: var(--_6f6f81-background);\n  border: 1px solid var(--_6f6f81-border);\n  color: var(--white-color);\n}\n.buttonTemplateButton {\n  text-decoration: underline;\n  color: var(--_2-color);\n  font-weight: 500;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  position: relative;\n}\n\n.buttonTemplate.filteredUserAutomationSelected {\n  position: relative;\n}\n\n.buttonTemplate.filteredUserAutomationSelected:hover::after {\n  content: \"Crea y Selecciona un automata\";\n  position: absolute;\n  top: 105%;\n  width: 200px;\n  color: var(--_0d-color);\n  padding: 2px 4px;\n  background: var(--white-background);\n  border-radius: 6px;\n  font-size: 12px;\n  box-shadow: 0 1px 1px var(--_0000001a-shadow);\n  z-index: 999999;\n}\n\n.buttonTemplateBorder{\n  border: 1px solid var(--cb-border);\n  background-color: var(--white-background);\n  padding: 8px;\n}\n\n\n.buttonTemplateLightGray{\n  background-color: var(--ececf1-background);\n  color: var(--_6e6e80-background);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonTemplate": `buttonTemplate__4qdJ`,
	"buttonTemplateGreen": `buttonTemplateGreen_q8yA5`,
	"buttonTemplateDiscard": `buttonTemplateDiscard_blUXu`,
	"buttonTemplateWhite": `buttonTemplateWhite_b3mAA`,
	"buttonTemplateGray": `buttonTemplateGray_jfNyC`,
	"buttonTemplateButton": `buttonTemplateButton_pG8qe`,
	"filteredUserAutomationSelected": `filteredUserAutomationSelected_uY2az`,
	"buttonTemplateBorder": `buttonTemplateBorder_ZwAb1`,
	"buttonTemplateLightGray": `buttonTemplateLightGray_sX6TD`
};
export default ___CSS_LOADER_EXPORT___;
